<script lang="ts">
  import type { BaseProps } from "#lib/internal/types"
  import { cn } from "#lib/utils"
  import type { Snippet } from "svelte"
  import { getDialogRootContext } from "./DialogRoot.svelte"

  type Props = BaseProps<"h2"> & {
    class?: string | undefined | null
    children?: Snippet
  }

  let { class: cssClass = "", children, ...restProps }: Props = $props()

  const rootCtx = getDialogRootContext()
</script>

<h2
  class={cn(
    "title font-xlarge-525 text-icon-general-primary flex flex-row items-center justify-between gap-2",
    cssClass
  )}
  id={$rootCtx.titleId}
  {...restProps}
>
  {@render children?.()}
</h2>
